module.exports = __webpack_public_path__ + "img/home-hero-woman-computer-1180.8ebd146.jpg";